import styled from 'styled-components';
import { H6 } from 'components/Typography';
import { sizes } from 'style';
import { th } from 'style/theme';

export const StyledSectionHeading = styled(H6)`
  margin-bottom: 16px;
  color: ${th('colors.turquoise')};

  @media ${sizes.desktop} {
    font-size: 20px;
  }

  > svg {
    position: relative;
    bottom: -3px;
    margin-left: 12px;
    cursor: pointer;
  }
`;
